// extracted by mini-css-extract-plugin
export var optionGrid = "_2k-7";
export var optionList = "_2k-6";
export var questionsBlock = "_2k-9";
export var spacer = "_2k-5";
export var stepCenteredContent = "_2k-3";
export var stepInner = "_2k-0";
export var stepInnerFullWidth = "_2k-1";
export var stepInnerLockScroll = "_2k-2";
export var stepTransitionFrame = "_2k-4";
export var welcomeBlock = "_2k-8";